import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
export type Theme = 'light' | 'dark' | 'system';
const key = 'repse-theme';
const valid = (value: string | null): Theme => value === 'light' || value === 'dark' ? value : 'system';
const ThemeContext = createContext<{theme: Theme; setTheme: (theme: Theme) => void}>({theme:'system',setTheme:()=>{}});
export function ThemeProvider({children}: {children: ReactNode}) {
  const [theme, setTheme] = useState<Theme>(() => { try { return valid(localStorage.getItem(key)); } catch { return 'system'; } });
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const apply = () => {
      const dark = theme === 'dark' || (theme === 'system' && media.matches);
      document.documentElement.classList.toggle('dark', dark);
      document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
      document.documentElement.dataset.theme = theme;
    };
    apply();
    media.addEventListener('change', apply);
    return () => media.removeEventListener('change', apply);
  }, [theme]);
  useEffect(() => {
    const sync = (event: StorageEvent) => { if (event.key === key || event.key === null) setTheme(valid(event.newValue)); };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  const choose = (value: Theme) => { setTheme(value); try { localStorage.setItem(key,value); } catch { /* Preference still applies in this tab. */ } };
  return <ThemeContext.Provider value={{theme,setTheme:choose}}>{children}</ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);
